import { ROUTES } from '@dashboard/router/routeNames'
import type { RouteLocationGeneric } from 'vue-router'
import { DETAIL_PAGES } from './services/otherDashboards'
import type { DetailView } from './types/details'

const detailPage = (view: DetailView) => ({
  name: DETAIL_PAGES[view].route,
  path: `dashboard/${view}`,
  component: () => import('./pages/DashboardDetails.vue'),
  props: { view },
  meta: {
    title: DETAIL_PAGES[view].name
  }
})

export default [
  {
    name: ROUTES.DASHBOARD_INDEX,
    path: '',
    redirect: (to: RouteLocationGeneric) => ({
      name: ROUTES.DASHBOARD,
      params: { teamPid: to.params.teamPid }
    })
  },
  // These pages were once tabs of `dashboard/details?tab=`; old links open the page their tab became.
  {
    path: 'dashboard/details',
    redirect: (to: RouteLocationGeneric) => {
      const { tab, ...query } = to.query
      const view: DetailView = tab === 'website' || tab === 'conversions' ? tab : 'audience'
      return { name: DETAIL_PAGES[view].route, params: { teamPid: to.params.teamPid }, query }
    }
  },
  detailPage('audience'),
  detailPage('website'),
  detailPage('conversions'),
  {
    name: ROUTES.DASHBOARD,
    path: 'dashboard',
    component: () => import('./pages/DashboardIndex.vue'),
    meta: {
      title: 'Dashboard',
      rightyPrompts: [
        {
          label: 'Weekly insights',
          drawerLabel: 'Summarize my key metrics this week',
          prompt:
            "Give me a summary of my key metrics and insights this week. What's working well and what needs attention?"
        },
        {
          label: 'Improvement ideas',
          drawerLabel: 'What should I focus on improving?',
          prompt: 'Based on my data, what are the top 3 things I should focus on to improve my results?'
        },
        {
          label: 'Spot anomalies',
          drawerLabel: 'Identify any unusual patterns or drops',
          prompt:
            'Look at my recent metrics and identify any unusual patterns, drops, or spikes that need attention. Is anything outside normal ranges?'
        },
        {
          label: 'Top performers',
          drawerLabel: 'Show me my top performers',
          prompt:
            "Which campaigns, offers, and segments are performing best right now? Highlight the winners and why they're succeeding."
        }
      ]
    }
  }
]
